import { ResponsiveSection } from '@stitch-fix/mode-react';
import type { NextPage } from 'next';
import { Layout } from '../../components/Layout';
import { OneTrustContent } from '../../components/OneTrustContent/OneTrustContent';
import { SEOData } from '../../components/SEOData';

const SupplyChainInformationPage: NextPage = () => {
  return (
    <Layout viewEventTrackingName="corporate">
      <SEOData
        title="Supply Chain Transparency | Stitch Fix"
        canonicalUrl="https://www.stitchfix.com/supply-chain-information"
      />
      <ResponsiveSection mt="0" width={{ sm: 'full-bleed' }} gutter="none">
        <OneTrustContent documentID="e01a7a04-3df8-4dae-b316-57a2d92bb8f9" />
      </ResponsiveSection>
    </Layout>
  );
};

export default SupplyChainInformationPage;
